import cn from 'classnames'
import React, { ComponentProps } from 'react'

type SvgPinIconProps = {
  className?: string
  filled?: boolean
  strokeColor?: string
  fillColor?: string
} & ComponentProps<'svg'>

const SvgPinIcon: React.FC<SvgPinIconProps> = ({
  className = '',
  filled = true,
  strokeColor = 'currentColor',
  fillColor = 'currentColor',
  ...rest
}) => {
  const appliedFill = filled ? fillColor : 'transparent'

  return (
    <svg
      className={cn('SvgPinIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8 11.333V14.6663"
        stroke={strokeColor}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00016 7.17301C6.00003 7.42106 5.9307 7.66417 5.79998 7.87498C5.66925 8.08579 5.4823 8.25596 5.26016 8.36634L4.0735 8.96634C3.85135 9.07673 3.66441 9.24689 3.53368 9.4577C3.40295 9.66852 3.33363 9.91162 3.3335 10.1597V10.6663C3.3335 10.8432 3.40373 11.0127 3.52876 11.1377C3.65378 11.2628 3.82335 11.333 4.00016 11.333H12.0002C12.177 11.333 12.3465 11.2628 12.4716 11.1377C12.5966 11.0127 12.6668 10.8432 12.6668 10.6663V10.1597C12.6667 9.91162 12.5974 9.66852 12.4666 9.4577C12.3359 9.24689 12.149 9.07673 11.9268 8.96634L10.7402 8.36634C10.518 8.25596 10.3311 8.08579 10.2003 7.87498C10.0696 7.66417 10.0003 7.42106 10.0002 7.17301V4.66634C10.0002 4.48953 10.0704 4.31996 10.1954 4.19494C10.3204 4.06991 10.49 3.99967 10.6668 3.99967C11.0205 3.99967 11.3596 3.8592 11.6096 3.60915C11.8597 3.3591 12.0002 3.01996 12.0002 2.66634C12.0002 2.31272 11.8597 1.97358 11.6096 1.72353C11.3596 1.47348 11.0205 1.33301 10.6668 1.33301H5.3335C4.97987 1.33301 4.64074 1.47348 4.39069 1.72353C4.14064 1.97358 4.00016 2.31272 4.00016 2.66634C4.00016 3.01996 4.14064 3.3591 4.39069 3.60915C4.64074 3.8592 4.97987 3.99967 5.3335 3.99967C5.51031 3.99967 5.67988 4.06991 5.8049 4.19494C5.92992 4.31996 6.00016 4.48953 6.00016 4.66634V7.17301Z"
        fill={appliedFill}
        stroke={strokeColor}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgPinIcon
